import React, { useState, useEffect } from 'react';
import "../AdminLayout.css";
import { IoClose } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const AlertNotification = () => {
 const navigate = useNavigate();
  
     const userData = useSelector((state) => state.auth.studentData);
  const [showNotification, setShowNotification] = useState(false);
  const [lastTransaction, setLastTransaction] = useState(null);

  useEffect(() => {
    if (userData && userData.transactions) {

      const transactions2026 = userData.transactions.filter(txn => {
        const txnDate = new Date(txn.created_at);
        const txnYear = txnDate.getFullYear();
        const amount = parseFloat(txn.amount);
        return txnYear === 2026 && amount === 1.00;
      });

      if (transactions2026.length > 0) {
        // Check if all transactions are failed
        const allFailed = transactions2026.every(txn => 
          txn.status === 'failure' || txn.unmappedstatus === 'userCancelled'
        );

        if (allFailed) {
          // Get the last transaction (most recent)
          const lastTxn = transactions2026[transactions2026.length - 1];
          setLastTransaction(lastTxn);
          setShowNotification(true);
        } else {
          // If any transaction is successful, don't show notification
          setShowNotification(false);
          setLastTransaction(null);
        }
      }
    }
  }, [userData]);

  const handleRetry = () => {
    
   navigate(`/student/payment?program=${lastTransaction.productinfo}`)
  };

  const handleClose = () => {
    setShowNotification(false);
    setLastTransaction(null);
  };

  if (!showNotification || !lastTransaction) {
    return null;
  }

  return (
    <div className='alert-notification'>
      <div className='alert-message'>
        <strong onClick={()=>console.log(lastTransaction)}>Payment Failed!</strong>
        <p>Your payment of ₹{lastTransaction.amount} for {lastTransaction.productinfo} was cancelled. Please retry.</p>
        <small>Transaction ID: {lastTransaction.txnid}</small>
      </div>
      <div className='alert-actions'>
        <button className='retry-btn' onClick={handleRetry}>
          Retry Payment
        </button>
        <IoClose className='close-icon' onClick={handleClose} />
      </div>
    </div>
  );
};

export default AlertNotification;